export default "__VITE_ASSET__BHhWjcV7__"